import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'

const ajax = axios.create({
  timeout: 10000,
  crossDomain: true,
  withCredentials: true
})

const paramsFromat = function(params) {
  if (params) {
    return '\n请求参数：\n' + decodeURI(params).split('&').join('\n')
  } else {
    return '\n请求参数：无'
  }
}

ajax.interceptors.request.use(function(config) {
  if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  if (config.url.indexOf('/saas/') > -1) {
    config.url = process.env.SAAS_BASE_API + config.url;
  } else if (config.url.indexOf('/shop/') > -1) {
    config.url = process.env.SHOP_BASE_API + config.url;
  } else if (config.url.indexOf('/admin/') > -1) {
    config.url = process.env.SAAS_BASE_API + config.url;
  } else {
    return Promise.reject('请求API不存在');
  }

  Vue.console.log('请求接口：' + config.url, paramsFromat(config.data))
  return Promise.resolve(config);
}, function(error) {
  Message({
    message: error,
    type: 'error',
    duration: 5000
  })
  return Promise.reject(error);
});

ajax.interceptors.response.use(function(response) {
  // console.log("ajax response", response);
  if (response.data.code !== 200) {
    /**
     * 服务异常登录，跳转登录页
     */
    if (response.data.code === 501) {
      Message({
        message: '您已经退出登录，请重新登录',
        type: 'error',
        duration: 1500,
        onClose: function() {
          store.dispatch('ClientLogout').then(() => {
            window.location.reload();
          })
        }
      });
      return Promise.reject('异常登录，请重新登录！');
    } else {
      return Promise.reject(response.data.msg);
    }
  } else {
    return Promise.resolve(response.data);
  }
}, function(error) {
  console.log('error', error)
  return Promise.reject(error);
});

export default ajax



// WEBPACK FOOTER //
// ./src/utils/http.js